import React from "react";
import { Header as AlphaHeader } from "alpha-ui";
import { useAuth } from "alpha-ui";
import {
  defaultFemale,
  defaultMale,
  defaultUser,
} from "../assets/images";



const GptHeader = () => {
  const { auth, handleLogout, refetchProfile } = useAuth();

  const profileUrl =
    `${process.env.REACT_APP_REDIRECT_LINK}/${auth?.user?.role === "13" || auth?.user?.role === "12"
      ? "teacher/profile"
      : auth?.user?.role === "11"
        ? "student/profile"
        : "parent/profile"
    }`;

  return (
    <AlphaHeader
      user={{
        id: auth?.user?._id,
        name: auth?.user?.first_name,
        avatar: auth?.user?.profile?.url
          ? auth.user.profile.url
          : auth?.user?.gender === "Male"
            ? defaultMale
            : auth?.user?.gender === "Female"
              ? defaultFemale
              : defaultUser,
        goals: auth?.user?.goals,
        role: auth?.user?.role,
      }}
      profileUrl={profileUrl}
      auth={{ onLogout: handleLogout }}
      onGoalUpdateSuccess={refetchProfile}
      scrollToGoalOnHome={false}
    />
  );
};

export default GptHeader;